import { render, staticRenderFns } from "./ScriptFex.vue?vue&type=template&id=8cc688ec&"
import script from "./ScriptFex.vue?vue&type=script&lang=js&"
export * from "./ScriptFex.vue?vue&type=script&lang=js&"
import style0 from "./ScriptFex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports